export default __webpack_public_path__ + "static/model_parts-f66a59ed4568474c5a8a42e355040487.svg";